import React, {FC} from 'react';

import {IconName} from '../../../../libs/shared/ui/src/components/icon/icon';
import {
  SettingsSearchDropdownContent,
  SettingsSearchDropdownGenericIcon,
  SettingsSearchDropdownItem,
  SettingsSearchDropdownItemLeftIcon,
  SettingsSearchDropdownSubtitle,
  SettingsSearchDropdownTitle,
} from './settingsSearchCommon';
import {SettingsSearchDropdownItemBaseProps} from './settingsSearchCommonTypes';

/*
 * Props.
 */

interface SettingsSearchDropdownGenericItemProps extends SettingsSearchDropdownItemBaseProps {
  iconName: IconName;
  label: React.ReactNode;
  title: React.ReactNode;
  subtitle: React.ReactNode;
}

/*
 * Component.
 */

export const SettingsSearchDropdownGenericItem: FC<SettingsSearchDropdownGenericItemProps> = (props) => (
  <SettingsSearchDropdownItem checkmarkLabel={props.label} onSelect={props.onSelect}>
    <SettingsSearchDropdownItemLeftIcon>
      <SettingsSearchDropdownGenericIcon name={props.iconName} />
    </SettingsSearchDropdownItemLeftIcon>
    <SettingsSearchDropdownContent>
      <SettingsSearchDropdownTitle>{props.title}</SettingsSearchDropdownTitle>
      <SettingsSearchDropdownSubtitle>{props.subtitle}</SettingsSearchDropdownSubtitle>
    </SettingsSearchDropdownContent>
  </SettingsSearchDropdownItem>
);
